<template>
  <v-container
    id="accountDetails"
    fluid
    tag="section"
    v-resize="onResize"
  >
  </v-container>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import {
    ACCT_GET_ACCOUNT_BY_EXT_KEY,
  } from '../../../store/actions.types'
  import {
    ACCT_UPDATE_SELECTED_ACCOUNT_KEY,
  } from '../../../store/mutations.types'
  import basicMixin from '../../../mixins/basic'

  export default {
    name: 'AccountDetails',
    components: {
    },
    mixins: [basicMixin],

    data () {
      return {

      }
    },
    watch: {
    },
    computed: {
      ...mapGetters([
        'acctCCErrors', 'acctAccounts', 'acctSelectedAccount', 'acctSelectedAccountUnpaidInvoices',
        'optsMonths', 'optsYears', 'acctIsUpdatingPaymentDetails', 'acctIsGettingAccountInvoices',
        'acctEcheckErrors', 'acctPostPaymentErrors', 'acctIsPostingPayment', 'acctSelectedAccountTickets',
        'acctSelectedAccountRates', 'authIsStaff',
      ]),
      ...mapGetters({
        selectedAccount: 'acctSelectedAccount',
      }),
    },
    async created () {
      // await this.doGetAccounts()
      console.log('page loaded')
      // console.log(this.accounts)
      console.log(this.$route)
      if (this.$route.params.platKey) {
        const payload = {
          key: this.$route.params.platKey,
          type: 'plat',
        }
        const redirectAccount = await this.getAccountByExtKey(payload)
        await this.$router.push({
          name: 'Customer Account',
          params: {
            rowkey: redirectAccount.rowkey,
          },
        })
      }
    },
    mounted () {
    },
    methods: {
      ...mapActions(['getAccount', 'getUnpaidInvoices', 'getECheckInfo',
                     'getCreditCardInfo']),
      ...mapActions({
        getAccountByExtKey: ACCT_GET_ACCOUNT_BY_EXT_KEY,
      }),
      ...mapMutations({
        setAccountKey: ACCT_UPDATE_SELECTED_ACCOUNT_KEY,
      }),
    },
  }
</script>
<style scoped>
  .list-lbl {
    width: 220px;
    font-weight: bold;
  }
</style>
